/**
  Copyright (c) [2022]
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

// Vue Imports
import { defineComponent } from 'vue';
// Components Imports
import HeaderDashboard from '@/components/header/header.vue';
import FooterDashboard from '@/components/footer/footer.vue';
import Paginator from '@/components/pagination/pagination.vue';

import { useNotificationStore } from '@dafcoe/vue-notification';
// Third party components
import moment from 'moment';
import VueElementLoading from 'vue-element-loading';
// store
import { mapState, mapActions } from 'vuex';
// Service Imports
import EventService from '@/services/event.ts';
// Router Imports
import router from '@/router';
// Defining Component
export default defineComponent({
  data() {
    return {
      recentOrderPayload: null,
      isloading: false,
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
      list: [],
    };
  },
  components: {
    HeaderDashboard,
    FooterDashboard,
    Paginator,
    'vue-element-loading': VueElementLoading,
  },
  computed: {
    ...mapState('events', ['selectedEvent']),
  },
  methods: {
    ...mapActions('events', ['setSelectedEvent']),
    approve(id) {
      this.isloading = true;
      EventService.approve({
        waitListId: id,
      })
        .then((response: any) => {
          if (response && response.Message) {
            const { setNotification } = useNotificationStore();
            setNotification({
              message: response.Message,
              type: response.Status == 'Success' ? 'success' : 'error',
              showIcon: false,
            });
          }
          this.isloading = false;
        })
        .catch((err: any) => {
          this.isloading = false;
        })
        .finally(() => {
          this.loadList();
        });
    },
    loadList() {
      this.isloading = true;
      EventService.waitingListRecords({
        eventId: this.selectedEvent.eventCode,
      })
        .then((response: any) => {
          if (response.Result && response.Result) {
            this.list = response.Result;
          }
          this.isloading = false;
        })
        .catch((err: any) => {
          this.isloading = false;
        });
    },
  },
  created() {
    localStorage.removeItem('record1');
    if (!this.selectedEvent) {
      let rr = localStorage.getItem('record');
      if (rr) {
        rr = JSON.parse(rr);
        this.setSelectedEvent(rr);
      }
    }
  },
  mounted() {
    let self = this;
    self.loadList();
  },
});
